
    export default 
    {
    "duplicate_order_confirm": {
        "dec1": "Hemos comprobado que ya has tramitado los pedidos",
        "dec2": "a AliExpress anteriormente. ¿Quieres volver a efectuar los pedidos a AliExpress? Esto podría crear pedidos duplicados.",
        "input_confirm": "Presiona CONFIRMAR para procesar los pedidos a AliExpress."
    }
}